const { auto } = require("@popperjs/core");

((myDoc)=>{


   // let myDoc = doc;

    Fancybox.bind('[data-fancybox="gallery"]');
    let staffSplide;

    const profileGallerySliders = (sliderEle) => {
        sliderEle = myDoc.querySelector(sliderEle);
        if(sliderEle){
            staffSplide = new Splide( sliderEle, {
                type: 'fade',
                //heightRatio: 0.55,
                //height: 450,
                pagination: false,
                arrows: false,
                cover: true,
            });
            
            var thumbnailSlider = new Splide('#thumbnail_slider', {
                rewind: true,
                fixedWidth: 125,
                fixedHeight: 105,
                isNavigation: true,
                arrows: true,
                gap: 10,
                focus: 'center',
                pagination: false,
                cover: true,
                breakpoints: {
                    '600': {
                        fixedWidth: 125,
                        fixedHeight: 105,
                    }
                }
            });
            thumbnailSlider.mount();
            staffSplide.sync(thumbnailSlider);
            
            staffSplide.mount();
        }
    }

    // let staffSlider = myDoc.querySelectorAll('.splideGallerySingleImage');
    // if(staffSlider){
    //     Object.keys(staffSlider).forEach(i=>{
    //         profileGallerySliders(staffSlider[i]);
    //     })
    // }

    profileGallerySliders('#profileImage-gallery');
    profileGallerySliders('#profileSelfie-gallery');

    let profileTabs = myDoc.querySelectorAll('.nav-tabs-profile button');
    if(profileTabs){
        let videoContainer = myDoc.querySelector('.gallery-single-video .row'),
        videos =  myDoc.querySelectorAll('.textareaVideo'),
        VideoHtml='';
        videoContainer?videoContainer.innerHTML = '':null;
        Object.keys(videos).forEach(i=>{
            //console.log(videos[i].getAttribute('value'));
            VideoHtml += `
            <div class="col-6 col-sm-4 col-md-3 mb-2 px-1">
                <div class="media-holder">
                    ${videos[i].getAttribute('value')}
                </div>
            </div>
            `
        });
        profileTabs.forEach(ele=>{
            ele.addEventListener('shown.bs.tab',(e)=>{
                if(e.target.id!=='video-tab'){
                    console.log(e.target.id);
                    staffSplide.refresh();
                }else{
                    if(VideoHtml && videoContainer !='') {
                        videoContainer.innerHTML=VideoHtml;
                    }
                }
                setTimeout(() => {
                    window.dispatchEvent(new Event('resize'));
                }, 100);
            })
        })
    }



    
    const tabEl = myDoc.querySelectorAll('.dropdown-menu button[data-bs-toggle="tab"]');
    const ratesDrop = myDoc.querySelector('.dropdown-rates');
    Object.keys(tabEl).forEach((i)=>{
        tabEl[i].addEventListener('shown.bs.tab', (event) => {
            //console.log(event.target.innerHTML);
            ratesDrop.querySelector('.btn-toggle').innerHTML = event.target.innerHTML;
        });
    });

    let splideReview = myDoc.querySelector('.splideReview');
    if(splideReview){
        var reviewSplide = new Splide( splideReview, {
            gap        : 20,
            arrows     : false,
            pagination : false,
            mediaQuery  : 'min',
            classes: {
                pagination: 'splide__pagination position-relative bottom-0 d-flex justify-content-md-end justify-content-center mt-4 px-0',
                page      : 'splide__pagination--page border-0 rounded-circle mx-1',
            },
            breakpoints: {
                1200: {
                    gap : 20,
                },
                992: {
                    perPage: 2,
                },
                576: {
                    perPage: 2,
                }
            }
        });
        reviewSplide.mount();
    };

    let youmaulike = myDoc.querySelectorAll('.homeStaffSlide');
    if(youmaulike){
        Object.keys(youmaulike).forEach((ele)=>{
            staffSplide = new Splide( youmaulike[ele], {
                gap: 6,
                        arrows: false,
                        pagination: false,
                        mediaQuery: 'min',
                        focus: 'center',
                        perPage: 1,
                        padding: 60,
                        breakpoints: {
                            768: {
                                perPage: 4,
                                gap: 10,
                                focus: 0,
                                padding: 0,
                            }
                        }

            });
            staffSplide.mount();
        })
    }





})(document);
